import 'swiper/swiper.min.css'

import SwiperCore, { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import main8swiper1 from '@/assets/main/main8/main8swiper1.png'
import main8swiper2 from '@/assets/main/main8/main8swiper2.png'
import main8swiper3 from '@/assets/main/main8/main8swiper3.png'
import main8swiper4 from '@/assets/main/main8/main8swiper4.png'
import main8swiper5 from '@/assets/main/main8/main8swiper5.png'
import main8swiper6 from '@/assets/main/main8/main8swiper6.png'
import phone_case from '@/assets/main/main8/phone_case.png'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { Main8SectionContent, Main8SectionItem, Main8SectionWrap } from '@/styles/views/Main/main8'

const Main8Section = () => {
  const { width } = useWindowDimensions()

  SwiperCore.use([Navigation, Pagination])

  const main8SwiperItem = [
    {
      idx: '1',
      imgSrc: main8swiper1,
      title: '앱 설치하기',
      desc: '구글 플레이스토어 또는 애플 앱스토어에서 ‘휴대폰가족보호’ 앱을 설치하세요.',
    },
    {
      idx: '2',
      imgSrc: main8swiper2,
      title: '회원가입하기',
      desc: '이용하시는 목적에 맞게 유,무료 회원가입을 완료해 주세요.',
    },
    {
      idx: '3',
      imgSrc: main8swiper3,
      title: '초대하기',
      desc: '주소록에서 가족, 연인, 친구 등을 선택하여 초대해 주세요.',
    },
    {
      idx: '4',
      imgSrc: main8swiper4,
      title: '위치 확인하기',
      desc: '바쁜 일상에서도 사랑하는 사람의 위치와 보호상태를 확인할 수 있어 쉽고 간편하게 보호가 가능해요.',
    },
    {
      idx: '5',
      imgSrc: main8swiper5,
      title: '활동량 확인하기',
      desc: '패밀리헬스에서 각 구성원의 활동량을 확인해 보세요.',
    },
    {
      idx: '6',
      imgSrc: main8swiper6,
      title: '패밀리알림',
      desc: '패밀리알림에서 가족의 상태에 대한 알림을 확인해 보세요.',
    },
  ]

  return (
    <Main8SectionWrap>
      <h3>쉽고 빠르게 서비스 이용하기</h3>
      <img src={phone_case} alt="" />
      <Main8SectionContent>
        <Swiper
          slidesPerView="auto"
          spaceBetween={width > 1200 ? 80 : -20}
          centeredSlides
          navigation
          loop
          style={{ margin: '0' }}
        >
          {main8SwiperItem.map((option: any) => (
            <SwiperSlide key={option.idx}>
              <Main8SectionItem>
                <img src={option.imgSrc} alt="" />
                <p>
                  <span>{option.idx}</span>
                  {option.title}
                </p>
                <span>{option.desc}</span>
              </Main8SectionItem>
            </SwiperSlide>
          ))}
        </Swiper>
      </Main8SectionContent>
    </Main8SectionWrap>
  )
}
export default Main8Section
